import React from 'react'
import PropTypes from 'prop-types'
import { LabeledField, omitLabelProps } from '@launchpadlab/lp-components'
import { Tooltip } from 'components'
import classnames from 'classnames'

const propTypes = {
  showTooltip: PropTypes.bool,
  tooltipContent: PropTypes.node,
  className: PropTypes.string,
}

const defaultProps = {
  showTooltip: false,
  tooltipContent: null,
  className: '',
}

function getOptionValue(value, options) {
  const matchingOption = options.find((option) => option.value == value)
  return matchingOption ? matchingOption.key : ''
}

function ReadOnlyCellInputWithTooltip(props) {
  const {
    input: { value },
    options,
    showTooltip,
    tooltipContent,
    className,
  } = omitLabelProps(props)

  const displayValue = options ? getOptionValue(value, options) : value
  const finalTooltipContent = tooltipContent || displayValue

  const content = (
    <div className={classnames('read-only-cell-input', className)}>
      <LabeledField {...props}>{displayValue}</LabeledField>
    </div>
  )

  if (showTooltip && finalTooltipContent) {
    return (
      <Tooltip icon={<u>View</u>} iconClassName="input-tooltip-icon">
        {content}
      </Tooltip>
    )
  }

  return content
}

ReadOnlyCellInputWithTooltip.propTypes = propTypes
ReadOnlyCellInputWithTooltip.defaultProps = defaultProps

export default ReadOnlyCellInputWithTooltip
